<template>
  <client-only>
    <v-select
      v-model="model"
      item-text="NameInHebrew"
      :placeholder="!model ? displayUsersExperience : formLabel"
      :items="items"
      solo
      rounded
      outlined
      dense
      required
      :rules="comboRules"
      return-object
    />
  </client-only>
</template>

<script>
import { has } from 'lodash';
import { comboRules } from '@/lib/rules.js';

export default {
  props: {
    fieldClass: {
      type: String,
      required: false,
      default: 'dr-field2',
    },
    currentExperience: {
      type: Object,
    },
  },
  data() {
    return {
      items: [
        { Code: 1, NameInHebrew: 'ללא נסיון' },
        { Code: 2, NameInHebrew: '1-2 שנים' },
        { Code: 3, NameInHebrew: '3-4 שנים' },
        { Code: 4, NameInHebrew: '5-6 שנים' },
        { Code: 5, NameInHebrew: '7 שנים ומעלה' },
      ],
      select: '',
      formLabel: 'נסיון',
      comboRules,
    };
  },

  computed: {
    model: {
      get() {
        return this.currentExperience ? this.normalizedExperience : '';
      },
      set(val) {
        this.select = val;
      },
    },

    normalizedExperience() {
      const tempExp = this.currentExperience;
      const normalExperience = {};
      if (has(tempExp, 'Name')) {
        normalExperience.NameInHebrew = tempExp.Name;
        normalExperience.Code = tempExp.Id;
      } else if (has(tempExp, 'NameInHebrew')) {
        normalExperience.NameInHebrew = tempExp.NameInHebrew;
        normalExperience.Code = tempExp.Code;
      }
      return normalExperience;
    },

    displayUsersExperience() {
      return this.currentExperience
        ? this.currentExperience.Name
        : this.forLabel;
    },

    isComplete() {
      return (
        this.model &&
        this.model.NameInHebrew &&
        this.model.NameInHebrew.length > 0
      );
    },
  },

  watch: {
    select() {
      if (this.select) {
        this.$emit('updateExperience', this.select.Code);
      }
    },
  },
  mounted() {
    this.isComplete;
  },
};
</script>
